const websiteVersion = process.env.NODE_ENV === 'development' ? '' : 'a0ac34c'

export default websiteVersion
